import { render, staticRenderFns } from "./ReportNotification.vue?vue&type=template&id=c15b341a&"
import script from "./ReportNotification.vue?vue&type=script&lang=js&"
export * from "./ReportNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports